import Tools from '@/util/js/tools'


export default{
    install(Vue,options)
    {

        for (var i in Tools) {
            Vue.prototype[i] = Tools[i];
          }

    }
  }



// WEBPACK FOOTER //
// ./src/util/tools.js